/**
 * Registration success route.
 */
import React, { lazy } from 'react';

import { Route } from 'react-router-dom';

const RegistrationSuccess = lazy(() => import('./RegistrationSuccess'));

const RegistrationSuccessRoute = (
    <Route
        key="registration-success"
        path="registration-success"
        element={<RegistrationSuccess />}
    />
);

export default RegistrationSuccessRoute;
